import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Typography } from '@mui/material'
import React from 'react'
import { WarningBanner } from 'src/Libs/flow/components'
import { BatteryNumber } from './ExtendedSettings'
import { BatteryOperationRange } from './ExtendedSettings/BatteryOperationRange'
import { ChargeBlockingTimes } from './ExtendedSettings/ChargeBlockingTimes'
import { DischargeBlockingTimes } from './ExtendedSettings/DischargeBlockingTimes'
import EmergencyPower from './ExtendedSettings/EmergencyPower'
import { StorageSystemEnergySavingMode } from './ExtendedSettings/StorageSystemEnergySavingMode'
import { WeatherForecastOptimization } from './ExtendedSettings/WeatherForecastOptimization'

type AdvancedSettingsComponent = React.FC<{ children: React.ReactNode }> & {
  BatteryNumber: typeof BatteryNumber
  WeatherForecastOptimization: typeof WeatherForecastOptimization
  BatteryOperationRange: typeof BatteryOperationRange
  EmergencyPower: typeof EmergencyPower
  StorageSystemEnergySavingMode: typeof StorageSystemEnergySavingMode
  ChargeBlockingTimes: typeof ChargeBlockingTimes
  DischargeBlockingTimes: typeof DischargeBlockingTimes
}

const AdvancedSettings: AdvancedSettingsComponent = ({ children }) => {
  const { t } = useCustomTranslation()

  return (
    <>
      <Typography variant="h2" mb={2}>
        {t('installation.storageConfig.advancedSettings')}
      </Typography>
      <WarningBanner>{t('installation.storageConfig.advancedSettingsWarning')}</WarningBanner>

      {children}
    </>
  )
}

export default AdvancedSettings

AdvancedSettings.BatteryNumber = BatteryNumber
AdvancedSettings.WeatherForecastOptimization = WeatherForecastOptimization
AdvancedSettings.BatteryOperationRange = BatteryOperationRange
AdvancedSettings.EmergencyPower = EmergencyPower
AdvancedSettings.StorageSystemEnergySavingMode = StorageSystemEnergySavingMode
AdvancedSettings.ChargeBlockingTimes = ChargeBlockingTimes
AdvancedSettings.DischargeBlockingTimes = DischargeBlockingTimes
